// Application Configuration

export const config = {
  API_URL:
    import.meta.env.VITE_API_URL ||
    'https://script.google.com/macros/s/AKfycbxHjx88-oC43i_PfFhKdjmaAxePwsgZD44CJnmpn4ySFrC5FkGU2fCG1SO0ruLutUYw/exec',
  VERSION: '4.0.0',
  CACHE_DURATION: 3600000, // 1 hour
  STORAGE_PREFIX: 'workout-',
};

export const STORAGE_KEYS = {
  THEME: 'theme',
  NOTE: 'note',
  COMPLETION: 'completion',
  COMPLETED: 'completed',
};

export const TABS = ['dashboard', 'training', 'progress', 'timer'];

export const WEEKS = ['W1', 'W2', 'W3', 'W4', 'W5', 'W6'];
